function in_array(needle, haystack, argStrict) {
    var key = '', strict = !!argStrict;
    if (strict) {
        for (key in haystack) {
            if (haystack[key] === needle) {
                return true;
            }
        }
    }
    else {
        for (key in haystack) {
            if (haystack[key] == needle) {
                return true;
            }
        }
    }
    return false;
}
 
function setCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) 
{
   return setCookie(name,"",-1);
}

function parseQuery(str)
{
    if(typeof str !== "string" || str.length === 0) return {};
    var s = str.split("&");
    var s_length = s.length;
    var bit, query = {}, first, second;
    for(var i = 0; i < s_length; i++)
    {
        bit = s[i].split("=");
        first = decodeURIComponent(bit[0]);
        if(first.length === 0) continue;
        second = decodeURIComponent(bit[1]);
        if(typeof query[first] === "undefined") query[first] = second;
        else if(query[first] instanceof Array) query[first].push(second);
        else query[first] = [query[first], second];
    }
    return query;
}

function scrollY() {
    return window.pageYOffset || window.document.documentElement.scrollTop;
}
function scroll2position(pos,t) {
    $('html, body').animate({scrollTop: pos}, t || 500);
}
function scroll2element(el) {
    var position = $(el).offset();
    var $padding = $('body').css('paddingTop').replace('px','');
    var y = position.top - $padding;
    
    $('html, body').stop().animate({scrollTop: y}, 'slow');

}

function viewport() {
    return {
        height: $(window).innerHeight(),
        width: $(window).innerWidth(),
        breakPoint: function() {
            var w = this.width;
            if (w <= 1200) {
                if (w <= 992) {
                    if (w <= 768) {
                        return 'xsmall';
                    } else {
                        return 'small';
                    }
                } else {
                    return 'medium';
                }
            } else {
                return 'large';
            }
        }
    }
}


function append_partial( container , cb){

    var d = container.data(),
        data = {};
    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }
    $('body').addClass('loading');
    container.css('min-height',container.height());
    container.addClass('loading');

    $.ajax({
        url     : '/partial/' + d.partial,
        data    : data,
        method  : 'GET',
        success: function (data) {
            var newContent = $(data.markup).find('.widget-content');
            newContent.find('img').on('error',missingImageLoad);

            var t = container.find('.widget-content').append(newContent.html());
           
            if(newContent.text().length == 0){
                container.hide();
            }else{
                container.show();
            }
            container.removeClass('loading');
            $('body').removeClass('loading');

			try {
				container.find('.widget-content .lazyload').lazyload();
                container.find('img').on('error',missingImageLoad);

			}catch(err) {
				container.find('.widget-content .lazyload').each(function(){
					var $this = $(this);
					$this.attr('src', $this.data('src'));
				});
			}
            container.find('.widget-content .lazyload').addClass('dd');

            skinFormElements(newContent);

            init('#' + container.attr('id'));

            $('#' + newContent.attr('id')).removeClass('loading');

            container.css('min-height','0');

            if(typeof(cb) !== 'undefined'){
                cb();
            }
        },
        error: function (response) {
            container.hide();
            //   AjaxForms.form_submit_response('ajax error','error');
        }
    });
}

var partials_pull = {};
function loading_partial(){
    if($.isEmptyObject(partials_pull)){
        $('body').removeClass('partials-loading');
    }else if(!$.isEmptyObject(partials_pull) ){
        $('body').addClass('partials-loading')
    }
}

function load_partial( container , cb){

    if(container.length == 0){
        return false;
    }


    var unique_partial_id = Math.floor(Math.random()* 1000000),
        d = container.data(),
        data = {};

    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }

    $('body').addClass('loading');
    container.css('opacity',0.5);
    container.css('min-height',container.height());
    container.addClass('loading');
    container.append('<div class="parial-loader">Loading...</div>');

    if(data){
        data.current_url = window.location.pathname;
    }

    partials_pull[unique_partial_id] = $.ajax({
        url     : '/partial/' + d.partial,
        data    : data,
        method  : 'GET',

        success: function (data) {

            delete partials_pull[unique_partial_id];

            var newContent = $(data.markup);


            
            //try {
                //newContent.find('.lazyload').lazyload();
                newContent.find('img').addClass('onError');
                newContent.find('img').on('error',missingImageLoad);
            //}catch(err) {
                //newContent.find('.lazyload').each(function(){
                   // var $this = $(this);
                   // $this.attr('src', $this.data('src'));
                //});
            //}    

        
            var t = container.replaceWith(newContent);
            
            
            t.find('img').on('load',function(){
                $(this).css('opacity',0).animate({opacity:1},400);
            });

            if(newContent.text().length == 0){
                container.hide();
            }else{
                container.show();
            } 

            container.removeClass('loading');
            $('body').removeClass('loading');
            container.find('.parial-loader').remove();

            skinFormElements('#' + newContent.attr('id'));
            init('#' + newContent.attr('id') );

            $('#' + newContent.attr('id')).removeClass('loading');

            container.css('min-height','0');
newContent.show();
            if(typeof(cb) !== 'undefined'){
                cb(newContent);
            }
            loading_partial();
        },
        error: function (response) {
            delete partials_pull[unique_partial_id];
            loading_partial();
        }
    });

    loading_partial();

}

function currency_format($amount, $currency) {
    return $currency + Number($amount, 2).toFixed(2);
}


function missingImageLoad(){
    var attempts = $(this).data('attempts');
    var src = $(this).attr('src').replace('//s3.iknowauto.com/', '//api.iknowauto.com/');
    $(this).attr('src',src);
    $(this).off('error',missingImageLoad);
}